// extracted by mini-css-extract-plugin
module.exports = {"centeredCTA":"style_centeredCTA__10zr3","paragraphGroup":"style_paragraphGroup__15MR3"};